import type { SceneContext } from '../_shared/types'
import type { RankingData } from './types'
import { rankingReveal } from './tick'

export default function RankingReveal({ data, time }: SceneContext) {
  const d = data as unknown as RankingData
  const sorted = [...(d.items || [])].sort((a, b) => a.rank - b.rank)
  const { revealState, revealIdx } = rankingReveal(data, time)

  if (revealState === 'idle' || revealIdx >= sorted.length) {
    const top = sorted[0]
    if (!top) return null
    return (
      <div className="pv-ranking" style={{ background: (data as any).bgColor || `linear-gradient(160deg, ${top.color}22, transparent)` }}>
        <div className="pv-rank-number" style={{ color: top.color }}>
          #{top.rank}
        </div>
        <div className="pv-rank-title">{top.name}</div>
        <div className="pv-rank-desc">{top.desc}</div>
        <div className="pv-rank-hashtag">#{d.title}</div>
      </div>
    )
  }
  const item = sorted[revealIdx]
  return (
    <div
      className="pv-ranking pv-ranking-revealing"
      style={{ background: (data as any).bgColor || `linear-gradient(160deg, ${item.color}22, transparent)` }}
    >
      <div className="pv-rank-countdown">{sorted.length - revealIdx}</div>
      <div className="pv-rank-number" style={{ color: item.color }}>
        #{item.rank}
      </div>
      <div className="pv-rank-title">{item.name}</div>
      <div className="pv-rank-desc">{item.desc}</div>
    </div>
  )
}
